import React from 'react';
import { TankDetails } from '../CargoTemperatureLogUtils';
import { getCategoryName } from '../CargoTemperatureLogUtils';
import { Category } from '../cargo-temp-log-config/CargoTempConfig.style';
import { CargoTempCategory } from '../../../types/ViewModel/CargoTempLog/CargoInTankItem';

interface CategoryElementProps {
    cargoTanks: TankDetails[];
    cargoNumber: string;
}

const CategoryElement: React.FC<CategoryElementProps> = ({ cargoTanks, cargoNumber }) => {
    const categoryType = cargoTanks.find((c) => c.cargoNumber === cargoNumber)?.category ?? CargoTempCategory.NonHeat;
    const categoryName = getCategoryName(cargoTanks.find((c) => c.cargoNumber === cargoNumber)?.category) ?? '';

    return (
        <Category categoryType={categoryType}>
            <span className="status-icon"></span>
            {categoryName}
        </Category>
    );
};

export default CategoryElement;
